// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3vPEM","requiredAsterisk":"Info_requiredAsterisk__10nib"};